<template>
  <div id="login" class="row justify-content-center bg-general">
    <div class="col-sm-12 col-md-9 col-lg-4">
      <div class="logo stack-on-top" />
      <div class="jumbotron jumb justify-content-center d-sm-none d-md-block">
        <div v-if="alert.message" :class="`alert ${alert.type}`" role="alert">{{ alert.message }}</div>
        <form @submit.prevent="onSubmit">
          <ValidationProvider
            v-slot="{errors}"
            mode="aggressive"
            :rules="phoneNumber.rules"
            persist
          >
            <label :for="phoneNumber.name">{{ phoneNumber.label }}</label>
            <input
              v-model="phoneNumber.value"
              :name="phoneNumber.name"
              :type="phoneNumber.type"
              class="form-control"
              :class="{'is-invalid': errors[0]}"
              @input="clearError"
            />
            <div class="invalid-feedback">{{ errors[0] }}</div>
          </ValidationProvider>
          <ValidationProvider
            v-slot="{errors}"
            mode="aggressive"
            :rules="resetPIN.rules"
            persist
            v-if="isPintSent"
          >
            <label :for="resetPIN.name">{{ resetPIN.label }}</label>
            <input
              v-model="resetPIN.value"
              :name="resetPIN.name"
              :type="resetPIN.type"
              class="form-control"
              :class="{'is-invalid': errors[0]}"
            />
            <div class="invalid-feedback">{{ errors[0] }}</div>
          </ValidationProvider>
          <br />
          <primary-button title="Submit" classes="btn btn-primary btn-block" :loading="isLoading" />
        </form>
        <button class="btn btn-block my-4" @click="resendCode" v-if="isPintSent">resend code</button>
        <hr />
        <router-link to="/login">
          <small>
            <strong class="text-center">Back to login</strong>
          </small>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PrimaryButton from "../../components/Buttons/PrimaryButton.vue";
import { ValidationProvider } from "vee-validate";
export default {
  name: "PasswordReset",
  components: {
    ValidationProvider,
    PrimaryButton
  },
  data() {
    return {
      phoneNumber: {
        label: "Phone Number",
        name: "phone",
        type: "tel",
        rules: "required|phone|digits:10",
        value: ""
      },
      resetPIN: {
        label: "PIN",
        name: "pin",
        type: "password",
        value: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      isLoading: "passwords/isLoading",
      isPintSent: "passwords/isPinSent"
    }),
    alert() {
      return this.$store.state.alert;
    }
  },

  methods: {
    onSubmit() {
      if (this.phoneNumber.value.trim() && this.resetPIN.value.trim()) {
        return this.$store
          .dispatch("passwords/getResetToken", {
            phoneNumber: this.phoneNumber.value,
            code: this.resetPIN.value
          })
          .then(res => this.$router.replace(`/passwords/update?token=${res}`))
          .catch(error => this.$store.dispatch("alert/error", error.message));
      }
      return this.$store.dispatch("passwords/getResetPIN", {
        phoneNumber: this.phoneNumber.value
      });
    },
    resendCode() {
      if (this.phoneNumber.value.trim()) {
        this.$store.dispatch("passwords/getResetPIN", {
          phoneNumber: this.phoneNumber.value
        });
      }
    },
    clearError() {
      this.$store.dispatch("alert/clear");
    }
  }
};
</script>

<style scoped>
#login {
  height: 100vh;
}

.jumb {
  margin-top: 25vh;
  padding-top: 15vh;
  position: relative;
}

.logo {
  position: absolute;
  height: 76px;
  width: 76px;
  top: 0;
  left: 0;
  background: url("../../assets/images/logo.png");
}

.stack-on-top {
  z-index: 1;
  margin: 20vh 0 0 42%;
}
</style>
